


document.addEventListener('DOMContentLoaded', function () {
    console.log('Custom script loaded');

    const requiredCheckbox = document.getElementById('register-form__agreement-required');
    const optionalCheckbox = document.getElementById('register-form__agreement-option');
    const thirdpartyCheckbox = document.getElementById('register-form__agreement-thirdparty');
    const hiddenTagsInput = document.querySelector('.register-form__tag');
    const hiddenMarketingInput = document.getElementById('register-form__accepts_marketing');

    // Periksa jika elemen-elemen yang dibutuhkan tersedia
    if (!requiredCheckbox || !optionalCheckbox || !thirdpartyCheckbox || !hiddenTagsInput || !hiddenMarketingInput) {
        console.warn('Register form elements not found. Script skipped.');
        return;
    }

    function updateHiddenInputs() {
        let values = [];
        if (requiredCheckbox.checked) {
            values.push('newsletter');
            hiddenMarketingInput.value = "true";
        } else {
            hiddenMarketingInput.value = "false";
        }
        if (optionalCheckbox.checked) {
            values.push('acceptCustomerProfiling');
        }
        if (thirdpartyCheckbox.checked) {
            values.push('acceptThirdParties');
        }
        hiddenTagsInput.value = values.join(',');
        console.log('Hidden input tags value:', hiddenTagsInput.value);
        console.log('Hidden input marketing value:', hiddenMarketingInput.value);
    }

    function handleCheckboxChange(event) {
        const checkbox = event.target;
        const spanElement = checkbox.nextElementSibling;
        if (checkbox.checked) {
            spanElement.classList.add('checked');
        } else {
            spanElement.classList.remove('checked');
        }
        console.log('Checkbox changed:', checkbox.checked);
        updateHiddenInputs();
    }

    requiredCheckbox.addEventListener('change', handleCheckboxChange);
    optionalCheckbox.addEventListener('change', handleCheckboxChange);
    thirdpartyCheckbox.addEventListener('change', handleCheckboxChange);

    document.querySelectorAll('.register-form__holder').forEach(function (label) {
        label.addEventListener('click', function () {
            const checkbox = label.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
            handleCheckboxChange({ target: checkbox });
        });
    });

    // Initialize hidden inputs on page load
    updateHiddenInputs();
});
